// Import the enhanced version with translation support
import LandingPageWithTranslation from './LandingPageWithTranslation';

// Export the translation-enabled version
const LandingPage = LandingPageWithTranslation;

export default LandingPage;
